module.exports = __webpack_public_path__ + "img/39600.449c0539.jpg";